/// <reference lib="webworker" />
import { active, idle, idleSoon } from "app/redux/slices/IdleSlice";
import { secToMs } from "app/utils/converter";
import { closeConversation } from "app/redux/slices/conversationSlice";

let reminderTimeout, idleTimeout;

const startTimers = ({ reminderInSec, idleInSec }) => {
  reminderTimeout = setTimeout(() => {
    postMessage({
      action: idleSoon.toString(),
    });
  }, secToMs(reminderInSec));

  idleTimeout = setTimeout(() => {
    postMessage({
      action: idle.toString(),
    });
  }, secToMs(idleInSec));
};

const clearTimers = () => {
  clearTimeout(reminderTimeout);
  clearTimeout(idleTimeout);
};

// eslint-disable-next-line no-restricted-globals
self.addEventListener("message", function (e) {
  switch (e.data.action) {
    case active.toString(): {
      clearTimers();
      startTimers(e.data);
      break;
    }
    case closeConversation.toString(): {
      clearTimers();
      break;
    }
    default: {
    }
  }
});
